(() => {
const existingRedeem = window.msiCheatCodeRedeem;

if (existingRedeem?.init) {
  existingRedeem.init(document);
  return;
}

/**
 * Weekly Daily Redeem
 * ------------------------------------------------------------
 * Product data starts from safe fallback values, then hydrates from the POST
 * Redeem Status API. The API must not expose hidden discount codes; this script
 * only merges the allowlisted display fields below.
 *
 * Safety note: fallback prices and savings remain `TBD` so customers do not see
 * misleading low prices when the API is unavailable.
 * ------------------------------------------------------------
 */

const FALLBACK_REDEEM_PRODUCTS = [
  {
    day: '2026-08-11',
    dayLabel: 'Tue',
    dateLabel: '11 Aug',
    status: 'locked',
    eyebrow: 'COMING SOON',
    productName: '---',
    description: '---',
    image: 'https://storage-asset.msi.com/event/2026/ec/uk/msi-cheat-code/images/dailyDrop-monday.png',
    icon: 'https://storage-asset.msi.com/event/2026/ec/uk/msi-cheat-code/images/icon-pd-vga.png',
    beforePrice: 'TBD',
    afterPrice: 'TBD',
    saving: 'TBD',
    buttonText: 'Locked',
    buttonUrl: '#'
  },
  {
    day: '2026-08-12',
    dayLabel: 'Wed',
    dateLabel: '12 Aug',
    status: 'locked',
    eyebrow: 'COMING SOON',
    productName: '---',
    description: '---',
    image: 'https://storage-asset.msi.com/event/2026/ec/uk/msi-cheat-code/images/dailyDrop-tuesday.png',
    icon: 'https://storage-asset.msi.com/event/2026/ec/uk/msi-cheat-code/images/icon-pd-mblc.png',
    beforePrice: 'TBD',
    afterPrice: 'TBD',
    saving: 'TBD',
    buttonText: 'Locked',
    buttonUrl: '#'
  },
  {
    day: '2026-08-13',
    dayLabel: 'Thu',
    dateLabel: '13 Aug',
    status: 'locked',
    eyebrow: 'COMING SOON',
    productName: '---',
    description: '---',
    image: 'https://storage-asset.msi.com/event/2026/ec/uk/msi-cheat-code/images/dailyDrop-wednesday.png',
    icon: 'https://storage-asset.msi.com/event/2026/ec/uk/msi-cheat-code/images/icon-pd-mnt.png',
    beforePrice: 'TBD',
    afterPrice: 'TBD',
    saving: 'TBD',
    buttonText: 'Locked',
    buttonUrl: '#'
  },
  {
    day: '2026-08-14',
    dayLabel: 'Fri',
    dateLabel: '14 Aug',
    status: 'locked',
    eyebrow: 'COMING SOON',
    productName: '---',
    description: '---',
    image: 'https://storage-asset.msi.com/event/2026/ec/uk/msi-cheat-code/images/dailyDrop-thursday.png',
    icon: 'https://storage-asset.msi.com/event/2026/ec/uk/msi-cheat-code/images/icon-pd-dtps.png',
    beforePrice: 'TBD',
    afterPrice: 'TBD',
    saving: 'TBD',
    buttonText: 'Locked',
    buttonUrl: '#'
  },
  {
    day: '2026-08-17',
    dayLabel: 'Mon',
    dateLabel: '17 Aug',
    status: 'locked',
    eyebrow: 'COMING SOON',
    productName: '---',
    description: '---',
    image: 'https://storage-asset.msi.com/event/2026/ec/uk/msi-cheat-code/images/dailyDrop-friday.png',
    icon: 'https://storage-asset.msi.com/event/2026/ec/uk/msi-cheat-code/images/icon-pd-roamii.png',
    beforePrice: 'TBD',
    afterPrice: 'TBD',
    saving: 'TBD',
    buttonText: 'Locked',
    buttonUrl: '#'
  },
  {
    day: '2026-08-18',
    dayLabel: 'Tue',
    dateLabel: '18 Aug',
    status: 'locked',
    eyebrow: 'COMING SOON',
    productName: '---',
    description: '---',
    image: 'https://storage-asset.msi.com/event/2026/ec/uk/msi-cheat-code/images/dailyDrop-saturday.png',
    icon: 'https://storage-asset.msi.com/event/2026/ec/uk/msi-cheat-code/images/icon-pd-mnt.png',
    beforePrice: 'TBD',
    afterPrice: 'TBD',
    saving: 'TBD',
    buttonText: 'Locked',
    buttonUrl: '#'
  }
];

const REDEEM_SECTION_SELECTOR = '[data-redeem-section], #dailyDrop';
const DEFAULT_REDEEM_STATUS_API_URL = 'https://shopify-api.msi.com/api/checkDiscountCodeUsed/uk';
// Minimal QA panel switch; panel UI and persistence live in the companion asset.
const ENABLE_REDEEM_STATUS_TEST_PANEL = true;
const THIS_WEEK_GROUP = 'this-week';
const NEXT_WEEK_GROUP = 'next-week';
const VALID_REDEEM_STATUSES = new Set(['redeemed', 'expired', 'live', 'locked']);
const VALID_DAY_LABEL_PATTERN = /^[A-Za-z]{3}$/;
const VALID_DATE_LABEL_PATTERN = /^\d{1,2}\s+[A-Za-z]{3}$/;
const DESKTOP_SHOWCASE_MQ = window.matchMedia('(min-width: 768px)');
const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Status metadata is centralized so future redeem states change one boundary.
const STATUS_CONFIG = {
  redeemed: {
    className: 'is-redeemed',
    label: 'Redeemed',
    eyebrow: 'REDEEMED',
    overlayLabel: 'REDEEMED',
    isCtaDisabled: true
  },
  expired: {
    className: 'is-expired',
    label: 'Expired',
    eyebrow: 'EXPIRED',
    overlayLabel: 'EXPIRED',
    isCtaDisabled: true
  },
  live: {
    className: 'is-live',
    label: 'Live now',
    eyebrow: 'LIVE NOW',
    isCtaDisabled: false
  },
  locked: {
    className: 'is-locked',
    label: 'Locked',
    eyebrow: 'COMING SOON',
    buttonText: 'Locked',
    isCtaDisabled: true
  }
};

const API_PRODUCT_FIELD_ALLOWLIST = [
  'status',
  'eyebrow',
  'productName',
  'description',
  'image',
  'icon',
  'beforePrice',
  'afterPrice',
  'saving',
  'buttonText',
  'buttonUrl'
];
const API_RENDERABLE_PRODUCT_FIELDS = ['productName', 'image', 'buttonUrl'];
const SHOWCASE_STATUS_CLASS_NAMES = ['is-redeemed', 'is-expired', 'is-locked'];
const NAVIGATION_KEYS = new Set(['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown', 'Home', 'End']);
const ANALYTICS_EVENT_NAMES = {
  redeemButtonClick: 'msi_cheat_code_redeem_click',
  codeCategoryClick: 'msi_cheat_code_category_click'
};
const ANALYTICS_CONTEXT_SELECTOR = '[data-analytics-campaign]';
const CODE_CATEGORY_CARD_SELECTOR = '.code-category-card[data-analytics-category-card]';
const redeemLogger = {
  warn: (...messages) => console.warn(...messages)
};

let isGlobalHeightSyncBound = false;
let isAnalyticsClickBound = false;
let redeemProductsFetchPromise = null;
let redeemBaseProducts = normalizeRedeemProducts(FALLBACK_REDEEM_PRODUCTS);
let redeemProducts = redeemBaseProducts;
let redeemTestPanelState = null;

function getStatusConfig(status) {
  return STATUS_CONFIG[status] || STATUS_CONFIG.locked;
}

function getStatusClassName(status) {
  return getStatusConfig(status).className;
}

function getStatusLabel(status) {
  return getStatusConfig(status).label;
}

function getStatusEyebrow(status) {
  return getStatusConfig(status).eyebrow;
}

function getStatusButtonText(status) {
  return getStatusConfig(status).buttonText;
}

function getOverlayLabel(status) {
  return getStatusConfig(status).overlayLabel || STATUS_CONFIG.redeemed.overlayLabel;
}

function isCtaDisabled(status) {
  return getStatusConfig(status).isCtaDisabled;
}

function getRedeemSection(root = document) {
  if (root.matches?.(REDEEM_SECTION_SELECTOR)) {
    return root;
  }

  return root.querySelector?.(REDEEM_SECTION_SELECTOR) || null;
}

function forEachRedeemSection(root, callback) {
  if (root.matches?.(REDEEM_SECTION_SELECTOR)) {
    callback(root);
    return;
  }

  root.querySelectorAll?.(REDEEM_SECTION_SELECTOR).forEach(callback);
}

function isTruthyApiValue(value) {
  return value === true || value === 1 || value === '1' || value === 'true';
}

function getApiDropDateValue(item) {
  const date = [item?.day, item?.date, item?.dropDate, item?.drop_date]
    .map((candidate) => (typeof candidate === 'string' ? candidate.trim() : ''))
    .find((candidate) => /^\d{4}-\d{2}-\d{2}$/.test(candidate));

  return date || '';
}

function getProductMatchKey(product) {
  return getApiDropDateValue(product) || product.date || product.day;
}

function parseDropDate(dropDate) {
  const [year, month, day] = dropDate.split('-').map(Number);

  if (!year || !month || !day) return null;

  return new Date(Date.UTC(year, month - 1, day));
}

function formatDayLabel(dropDate) {
  const date = parseDropDate(dropDate);

  return date ? DAY_LABELS[date.getUTCDay()] : 'TBD';
}

function formatDateLabel(dropDate) {
  const date = parseDropDate(dropDate);

  return date ? `${date.getUTCDate()} ${MONTH_LABELS[date.getUTCMonth()]}` : 'TBD';
}

function getIsoWeekKey(dropDate) {
  const date = parseDropDate(dropDate);

  if (!date) return '';

  const thursday = new Date(date);
  const weekday = thursday.getUTCDay() || 7;
  thursday.setUTCDate(thursday.getUTCDate() + 4 - weekday);

  const yearStart = new Date(Date.UTC(thursday.getUTCFullYear(), 0, 1));
  const weekNumber = Math.ceil((((thursday - yearStart) / 86400000) + 1) / 7);

  return `${thursday.getUTCFullYear()}-${weekNumber}`;
}

function getWeekGroupForDropDate(dropDate, firstDropDate) {
  return getIsoWeekKey(dropDate) === getIsoWeekKey(firstDropDate)
    ? THIS_WEEK_GROUP
    : NEXT_WEEK_GROUP;
}

function createDefaultRedeemProduct(dropDate) {
  return {
    day: dropDate,
    date: dropDate,
    dayLabel: formatDayLabel(dropDate),
    dateLabel: formatDateLabel(dropDate),
    weekGroup: NEXT_WEEK_GROUP,
    status: 'locked',
    eyebrow: 'COMING SOON',
    productName: '---',
    description: '---',
    image: '',
    icon: '',
    beforePrice: 'TBD',
    afterPrice: 'TBD',
    saving: 'TBD',
    buttonText: 'Locked',
    buttonUrl: '#'
  };
}

function hasRenderableApiProductFields(item) {
  return API_RENDERABLE_PRODUCT_FIELDS.some((fieldName) => (
    normalizeDisplayValue(item?.[fieldName]).trim() !== ''
  ));
}

function sortProductsByDropDate(firstProduct, secondProduct) {
  return getProductMatchKey(firstProduct).localeCompare(getProductMatchKey(secondProduct));
}

function normalizeDisplayValue(value) {
  if (value === null || value === undefined) return '';
  return String(value);
}

function normalizePriceValue(value) {
  if (value === null || value === undefined || value === '') return '';

  if (typeof value === 'number') {
    return Number.isFinite(value) ? `£${value.toFixed(2)}` : '';
  }

  const normalizedValue = String(value).trim();
  const numericValue = Number(normalizedValue.replace(/,/g, ''));

  if (Number.isFinite(numericValue)) {
    return `£${numericValue.toFixed(2)}`;
  }

  return normalizedValue;
}

function normalizeDayLabelValue(value, fallbackLabel) {
  const label = normalizeDisplayValue(value).trim();

  if (!VALID_DAY_LABEL_PATTERN.test(label)) {
    return fallbackLabel;
  }

  return label;
}

function normalizeDateLabelValue(value, fallbackLabel) {
  const label = normalizeDisplayValue(value).trim();

  if (!VALID_DATE_LABEL_PATTERN.test(label)) {
    return fallbackLabel;
  }

  return label;
}

function normalizeAnalyticsValue(value) {
  if (value === null || value === undefined) return '';

  if (typeof value === 'number' || typeof value === 'boolean') {
    return value;
  }

  return String(value).trim();
}

function getLinkUrl(link) {
  return normalizeAnalyticsValue(link?.href || link?.getAttribute?.('href'));
}

function getAnalyticsContext(element) {
  const context = element?.closest?.(ANALYTICS_CONTEXT_SELECTOR);

  return {
    campaign_name: normalizeAnalyticsValue(context?.dataset?.analyticsCampaign || 'msi_cheat_code'),
    section_id: normalizeAnalyticsValue(context?.dataset?.analyticsSectionId),
    page_location: normalizeAnalyticsValue(window.location.href),
    page_path: normalizeAnalyticsValue(window.location.pathname)
  };
}

function dispatchAnalyticsEvent(eventName, params) {
  const eventParams = Object.fromEntries(
    Object.entries(params).map(([key, value]) => [key, normalizeAnalyticsValue(value)])
  );

  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams);
    return;
  }

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({
      event: eventName,
      ...eventParams
    });
  }
}

function getRedeemButtonAnalyticsParams(buttonEl) {
  const product = getProductByDay(buttonEl?.dataset?.redeemDay) || getInitialProduct() || {};

  return {
    ...getAnalyticsContext(buttonEl),
    event_category: 'MSI Cheat Code',
    link_type: 'redeem_showcase_button',
    link_text: buttonEl?.textContent,
    link_url: getLinkUrl(buttonEl),
    product_name: product.productName,
    drop_date: product.day,
    drop_day_label: product.dayLabel,
    drop_date_label: product.dateLabel,
    week_group: product.weekGroup,
    redeem_status: product.status,
    before_price: product.beforePrice,
    after_price: product.afterPrice,
    saving: product.saving,
    cta_disabled: isCtaDisabled(product.status || 'locked')
  };
}

function getCodeCategoryAnalyticsParams(cardEl) {
  return {
    ...getAnalyticsContext(cardEl),
    event_category: 'MSI Cheat Code',
    link_type: 'code_category_card',
    link_text: cardEl?.dataset?.analyticsCategoryTitle || cardEl?.textContent,
    link_url: getLinkUrl(cardEl),
    category_title: cardEl?.dataset?.analyticsCategoryTitle,
    category_position: cardEl?.dataset?.analyticsCategoryPosition,
    category_block_id: cardEl?.dataset?.analyticsCategoryBlockId
  };
}

function getAnalyticsClickTarget(event) {
  return event.target instanceof Element
    ? event.target
    : event.target?.parentElement || null;
}

function handleAnalyticsClick(event) {
  const target = getAnalyticsClickTarget(event);
  const redeemButton = target?.closest('[data-redeem-button]');

  // Analytics payloads stay display-only: no customer identifiers or hidden codes.
  if (redeemButton) {
    dispatchAnalyticsEvent(
      ANALYTICS_EVENT_NAMES.redeemButtonClick,
      getRedeemButtonAnalyticsParams(redeemButton)
    );
    return;
  }

  const codeCategoryCard = target?.closest(CODE_CATEGORY_CARD_SELECTOR);

  if (codeCategoryCard) {
    dispatchAnalyticsEvent(
      ANALYTICS_EVENT_NAMES.codeCategoryClick,
      getCodeCategoryAnalyticsParams(codeCategoryCard)
    );
  }
}

function bindAnalyticsClickTracking(root = document) {
  if (isAnalyticsClickBound || root !== document) return;
  isAnalyticsClickBound = true;

  document.addEventListener('click', handleAnalyticsClick, true);
}

function getRedeemStatusApiUrl(section) {
  const configuredUrl = section?.dataset?.redeemStatusApiUrl?.trim();

  return configuredUrl || DEFAULT_REDEEM_STATUS_API_URL;
}

// API adapter: accept known legacy shapes, then emit normalized product updates.
function normalizeApiStatus(item) {
  const status = String(item?.status || item?.redeemStatus || item?.state || '').toLowerCase();

  if (VALID_REDEEM_STATUSES.has(status)) {
    return status;
  }

  const usedValue = item?.isUsed ?? item?.used ?? item?.discountCodeUsed ?? item?.discount_code_used ?? item?.redeemed;
  return isTruthyApiValue(usedValue) ? 'redeemed' : null;
}

function getApiUpdateSource(payload) {
  if (Array.isArray(payload)) return payload;

  if (!payload || typeof payload !== 'object') return null;

  return (
    payload.redeemProducts ||
    payload.products ||
    payload.items ||
    payload.result ||
    payload.data ||
    null
  );
}

function buildProductStatusUpdates(payload) {
  const source = getApiUpdateSource(payload);

  if (Array.isArray(source)) {
    return source;
  }

  if (source && typeof source === 'object') {
    const directStatus = normalizeApiStatus(source);

    if (directStatus) {
      return [source];
    }

    return Object.entries(source).map(([day, value]) => ({
      ...(value && typeof value === 'object' ? value : { used: value }),
      day
    }));
  }

  const directStatus = normalizeApiStatus(payload);
  return directStatus ? [payload] : [];
}

function normalizeApiProduct(item, fallbackProduct) {
  const { firstDropDate, ...fallbackProductFields } = fallbackProduct;
  const dropDate = getApiDropDateValue(item) || getProductMatchKey(fallbackProduct);
  const nextProduct = {
    ...createDefaultRedeemProduct(dropDate),
    ...fallbackProductFields
  };

  API_PRODUCT_FIELD_ALLOWLIST.forEach((fieldName) => {
    if (!Object.prototype.hasOwnProperty.call(item, fieldName)) return;

    if (fieldName === 'beforePrice' || fieldName === 'afterPrice') {
      nextProduct[fieldName] = normalizePriceValue(item[fieldName]);
      return;
    }

    nextProduct[fieldName] = normalizeDisplayValue(item[fieldName]);
  });

  const status = normalizeApiStatus(item) || fallbackProduct.status;
  nextProduct.status = status;
  nextProduct.day = dropDate;
  nextProduct.date = dropDate;
  nextProduct.weekGroup = getWeekGroupForDropDate(dropDate, firstDropDate || dropDate);
  // Display labels are presentation-only; Drop Date remains the matching key.
  nextProduct.dayLabel = Object.prototype.hasOwnProperty.call(item, 'dayLabel')
    ? normalizeDayLabelValue(item.dayLabel, fallbackProduct.dayLabel)
    : fallbackProduct.dayLabel;
  nextProduct.dateLabel = Object.prototype.hasOwnProperty.call(item, 'dateLabel')
    ? normalizeDateLabelValue(item.dateLabel, fallbackProduct.dateLabel)
    : fallbackProduct.dateLabel;
  nextProduct.eyebrow = nextProduct.eyebrow || getStatusEyebrow(status) || fallbackProduct.eyebrow;
  nextProduct.buttonText = getStatusButtonText(status) || nextProduct.buttonText || fallbackProduct.buttonText;

  return nextProduct;
}

function normalizeRedeemProducts(products) {
  const datedProducts = products
    .map((product) => ({
      product,
      dropDate: getProductMatchKey(product)
    }))
    .filter(({ dropDate }) => /^\d{4}-\d{2}-\d{2}$/.test(dropDate))
    .sort((firstItem, secondItem) => firstItem.dropDate.localeCompare(secondItem.dropDate));
  const firstDropDate = datedProducts[0]?.dropDate || '';

  return datedProducts.map(({ product, dropDate }) => normalizeApiProduct(
    product,
    {
      ...createDefaultRedeemProduct(dropDate),
      firstDropDate
    }
  ));
}

function mergeRedeemProductsWithApiData(currentProducts, payload) {
  const currentProductMap = new Map(
    normalizeRedeemProducts(currentProducts).map((product) => [product.date, product])
  );
  const updatesByDate = new Map();

  // API `day` is the Drop Date; UI-only week grouping is derived after all dates are known.
  buildProductStatusUpdates(payload).forEach((item) => {
    const date = getApiDropDateValue(item);

    if (date) {
      updatesByDate.set(date, item);

      if (!currentProductMap.has(date)) {
        redeemLogger.warn(`Redeem status API returned an unmatched Drop Date: ${date}`);

        if (hasRenderableApiProductFields(item)) {
          currentProductMap.set(date, createDefaultRedeemProduct(date));
        }
      }
    }
  });

  if (!updatesByDate.size) return normalizeRedeemProducts(currentProducts);

  const dropDates = [...currentProductMap.keys()].sort((firstDate, secondDate) => firstDate.localeCompare(secondDate));
  const firstDropDate = dropDates[0] || '';

  return dropDates.map((date) => {
    const product = currentProductMap.get(date);
    const item = updatesByDate.get(date) || product;

    return normalizeApiProduct(item, {
      ...product,
      firstDropDate
    });
  });
}

async function fetchRedeemProducts(section) {
  const apiUrl = getRedeemStatusApiUrl(section);

  if (!apiUrl || typeof window.fetch !== 'function') {
    return redeemBaseProducts;
  }

  if (redeemTestPanelState?.scenario) {
    const scenarioError = getRedeemTestPanel()?.getScenarioError?.(redeemTestPanelState.scenario);

    if (scenarioError) {
      throw new Error(scenarioError);
    }

    return mergeRedeemProductsWithApiData(
      redeemBaseProducts,
      getRedeemTestScenarioPayload(redeemTestPanelState.scenario)
    );
  }

  if (!redeemProductsFetchPromise) {
    // The status endpoint returns all current drops and does not require request parameters.
    redeemProductsFetchPromise = window.fetch(apiUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      credentials: 'omit',
      cache: 'no-store'
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Redeem status API returned ${response.status}`);
        }

        return response.json();
      })
      .then((payload) => {
        if (payload?.status === 'error') {
          throw new Error(`Redeem status API error: ${payload.message_code || 'unknown'}`);
        }

        return mergeRedeemProductsWithApiData(redeemBaseProducts, payload);
      })
      .catch((error) => {
        redeemProductsFetchPromise = null;
        throw error;
      });
  }

  return redeemProductsFetchPromise;
}

async function hydrateRedeemProducts(section) {
  try {
    const nextProducts = await fetchRedeemProducts(section);

    if (nextProducts === redeemBaseProducts) return false;

    redeemBaseProducts = nextProducts;
    redeemProducts = getRedeemProductsWithTestState(redeemBaseProducts);
    return true;
  } catch (error) {
    redeemLogger.warn('Redeem status API unavailable; using fallback product data.', error);
    return false;
  }
}

function getRedeemTestPanel() {
  if (!ENABLE_REDEEM_STATUS_TEST_PANEL) return null;

  return window.msiCheatCodeRedeemTestPanel?.init
    ? window.msiCheatCodeRedeemTestPanel
    : null;
}

function getRedeemProductsWithTestState(baseProducts) {
  if (!redeemTestPanelState) return baseProducts;

  if (redeemTestPanelState.scenario) {
    const fallbackProducts = FALLBACK_REDEEM_PRODUCTS.map((product) => ({ ...product }));
    return mergeRedeemProductsWithApiData(
      fallbackProducts,
      getRedeemTestScenarioPayload(redeemTestPanelState.scenario)
    );
  }

  const updates = Object.entries(redeemTestPanelState.overrides).map(([day, status]) => ({
    day,
    status
  }));

  return mergeRedeemProductsWithApiData(baseProducts, updates);
}

function getRedeemTestScenarioPayload(scenario) {
  return getRedeemTestPanel()?.getScenarioPayload?.(scenario) || [];
}

function applyRedeemTestPanelState(nextState = redeemTestPanelState) {
  redeemTestPanelState = nextState;
  redeemProducts = getRedeemProductsWithTestState(redeemBaseProducts);
  getRedeemTestPanel()?.syncState?.(redeemTestPanelState);
  forEachRedeemSection(document, renderRedeemSection);
}

function resetRedeemTestPanelState() {
  if (!redeemTestPanelState) return;

  redeemTestPanelState = { overrides: {}, scenario: null };
  applyRedeemTestPanelState();
  redeemProductsFetchPromise = null;

  forEachRedeemSection(document, (section) => {
    hydrateRedeemProducts(section).then((didUpdate) => {
      if (didUpdate) {
        renderRedeemSection(section);
      }
    });
  });
}

function initRedeemTestPanel() {
  const testPanel = getRedeemTestPanel();
  if (!testPanel) return;

  redeemTestPanelState = testPanel.getInitialState?.({
    enabled: ENABLE_REDEEM_STATUS_TEST_PANEL,
    logger: redeemLogger,
    validStatuses: VALID_REDEEM_STATUSES
  }) || null;
  redeemProducts = getRedeemProductsWithTestState(redeemBaseProducts);

  if (!redeemTestPanelState) return;

  testPanel.init({
    getProducts: () => redeemBaseProducts,
    getState: () => redeemTestPanelState,
    resetState: resetRedeemTestPanelState,
    setState: applyRedeemTestPanelState,
    validStatuses: VALID_REDEEM_STATUSES
  });
}

function getProductByDay(day) {
  return redeemProducts.find((item) => item.day === day);
}

function getInitialProduct() {
  return (
    redeemProducts.find((item) => item.status === 'live') ||
    redeemProducts[0]
  );
}

function setTextIfPresent(element, text) {
  if (element) {
    element.textContent = text;
  }
}

function updateButtonState(buttonEl, status, product) {
  const disabled = isCtaDisabled(status);

  buttonEl.textContent = product.buttonText;
  buttonEl.dataset.redeemDay = product.day;
  buttonEl.dataset.redeemStatus = product.status;
  buttonEl.classList.toggle('is-disabled', disabled);
  buttonEl.setAttribute('aria-disabled', String(disabled));

  if (disabled) {
    buttonEl.setAttribute('href', '#');
    buttonEl.setAttribute('tabindex', '-1');
  } else {
    buttonEl.setAttribute('href', product.buttonUrl || '#');
    buttonEl.removeAttribute('tabindex');
  }
}

function updateRedeemStatus(status, root = document) {
  const section = getRedeemSection(root);
  if (!section) return;

  const showcase = section.querySelector('[data-redeem-showcase]');
  const overlayLabelEl = section.querySelector('[data-redeem-overlay-label]');
  if (!showcase) return;

  showcase.classList.remove(...SHOWCASE_STATUS_CLASS_NAMES);

  if (SHOWCASE_STATUS_CLASS_NAMES.includes(getStatusClassName(status))) {
    showcase.classList.add(getStatusClassName(status));
  }

  setTextIfPresent(overlayLabelEl, getOverlayLabel(status));
}

function updateShowcase(product, root = document) {
  const section = getRedeemSection(root);
  if (!section) return;

  const imageEl = section.querySelector('[data-redeem-image]');
  const eyebrowEl = section.querySelector('[data-redeem-eyebrow]');
  const titleEl = section.querySelector('[data-redeem-title]');
  const descriptionEl = section.querySelector('[data-redeem-description]');
  const priceBeforeEl = section.querySelector('[data-redeem-price-before]');
  const priceAfterEl = section.querySelector('[data-redeem-price-after]');
  const savingEl = section.querySelector('[data-redeem-saving]');
  const buttonEl = section.querySelector('[data-redeem-button]');

  if (!product || !imageEl || !buttonEl) return;

  imageEl.src = product.image;
  imageEl.alt = product.productName;
  setTextIfPresent(eyebrowEl, product.eyebrow);
  setTextIfPresent(titleEl, product.productName);
  setTextIfPresent(descriptionEl, product.description);
  setTextIfPresent(priceBeforeEl, product.beforePrice);
  setTextIfPresent(priceAfterEl, product.afterPrice);
  setTextIfPresent(savingEl, product.saving);

  updateButtonState(buttonEl, product.status, product);
  updateRedeemStatus(product.status, section);
}

// Layout service: temporarily renders each product to measure the tallest content.
function syncShowcaseContentHeight(root = document) {
  const section = getRedeemSection(root);
  if (!section) return;

  const showcase = section.querySelector('[data-redeem-showcase]');
  const contentEl = section.querySelector('.redeem-showcase__content');
  if (!showcase || !contentEl || !redeemProducts.length) return;

  if (!DESKTOP_SHOWCASE_MQ.matches) {
    contentEl.style.minHeight = '';
    return;
  }

  const activeDay = section
    .querySelector('.redeem-daily-card.is-active')
    ?.getAttribute('data-day');
  const currentProduct =
    getProductByDay(activeDay) || getInitialProduct();

  const previousVisibility = showcase.style.visibility;
  showcase.style.visibility = 'hidden';
  contentEl.style.minHeight = '';

  let maxHeight = 0;

  redeemProducts.forEach((product) => {
    updateShowcase(product, section);
    maxHeight = Math.max(maxHeight, contentEl.offsetHeight);
  });

  contentEl.style.minHeight = `${maxHeight}px`;
  showcase.style.visibility = previousVisibility;

  if (currentProduct) {
    updateShowcase(currentProduct, section);
  }
}

function syncAllShowcaseContentHeights() {
  forEachRedeemSection(document, syncShowcaseContentHeight);
}

function bindShowcaseHeightSync() {
  if (isGlobalHeightSyncBound) return;
  isGlobalHeightSyncBound = true;

  const scheduleSync = () => {
    window.clearTimeout(bindShowcaseHeightSync.resizeTimer);
    bindShowcaseHeightSync.resizeTimer = window.setTimeout(syncAllShowcaseContentHeights, 150);
  };

  window.addEventListener('resize', scheduleSync);

  if (typeof DESKTOP_SHOWCASE_MQ.addEventListener === 'function') {
    DESKTOP_SHOWCASE_MQ.addEventListener('change', syncAllShowcaseContentHeights);
  } else if (typeof DESKTOP_SHOWCASE_MQ.addListener === 'function') {
    DESKTOP_SHOWCASE_MQ.addListener(syncAllShowcaseContentHeights);
  }
}
bindShowcaseHeightSync.resizeTimer = null;

function setActiveDay(selectedButton, root = document) {
  const section = getRedeemSection(root);
  if (!section) return;

  const cards = section.querySelectorAll('.redeem-daily-card');

  cards.forEach((card) => {
    const isActive = card === selectedButton;
    card.classList.toggle('is-active', isActive);
    card.setAttribute('aria-selected', String(isActive));
  });
}

function createDailyCard(product) {
  const button = document.createElement('button');
  const statusClass = getStatusClassName(product.status);
  const isLocked = product.status === 'locked';
  const lockOverlay = document.createElement('span');
  const lockIcon = document.createElement('img');
  const dayBox = document.createElement('div');
  const dayLabel = document.createElement('span');
  const dateLabel = document.createElement('span');
  const icon = document.createElement('img');
  const statusLabel = document.createElement('span');

  button.type = 'button';
  button.className = `redeem-daily-card ${statusClass}`;
  button.setAttribute('role', 'tab');
  button.setAttribute('data-day', product.day);
  button.setAttribute('aria-selected', 'false');

  if (isLocked) {
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
  }

  if (isLocked) {
    lockOverlay.className = 'redeem-daily-card__lock';
    lockOverlay.setAttribute('aria-hidden', 'true');
    lockIcon.className = 'redeem-daily-card__lock-icon';
    lockIcon.src = 'https://storage-asset.msi.com/event/2026/ec/uk/msi-cheat-code/images/icon-locked.png';
    lockIcon.alt = '';
    lockOverlay.appendChild(lockIcon);
    button.appendChild(lockOverlay);
  }

  dayBox.className = 'redeem-daily-card__dayBox';
  dayLabel.className = 'redeem-daily-card__day';
  dayLabel.textContent = product.dayLabel;
  dateLabel.className = 'redeem-daily-card__date';
  dateLabel.textContent = product.dateLabel;
  dayBox.append(dayLabel, dateLabel);

  icon.className = 'redeem-daily-card__icon';
  icon.src = product.icon;
  icon.alt = '';

  statusLabel.className = 'redeem-daily-card__status';
  statusLabel.textContent = getStatusLabel(product.status);

  button.append(dayBox, icon, statusLabel);

  return button;
}

function renderDailyNav(root = document) {
  const section = getRedeemSection(root);
  if (!section) return;

  const navs = section.querySelectorAll('[data-redeem-nav]');
  if (!navs.length) return;

  navs.forEach((nav) => {
    const weekGroup = nav.dataset.redeemNav;
    const products = redeemProducts.filter((product) => !weekGroup || product.weekGroup === weekGroup);

    nav.innerHTML = '';
    products.forEach((product) => {
      nav.appendChild(createDailyCard(product));
    });
  });
}

function getEnabledDailyCards(section) {
  return Array.from(section.querySelectorAll('.redeem-daily-card')).filter((card) => (
    !card.disabled &&
    !card.classList.contains('is-locked')
  ));
}

function focusDailyCardByKey(event, selectedButton, section) {
  if (!NAVIGATION_KEYS.has(event.key)) return;

  const cards = getEnabledDailyCards(section);
  if (!cards.length) return;

  const currentIndex = Math.max(cards.indexOf(selectedButton), 0);
  let nextIndex = currentIndex;

  if (event.key === 'Home') {
    nextIndex = 0;
  } else if (event.key === 'End') {
    nextIndex = cards.length - 1;
  } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
    nextIndex = (currentIndex + 1) % cards.length;
  } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
    nextIndex = (currentIndex - 1 + cards.length) % cards.length;
  }

  event.preventDefault();
  cards[nextIndex].focus();
}

function activateDailyCard(selectedButton, section) {
  if (
    selectedButton.disabled ||
    selectedButton.classList.contains('is-locked')
  ) {
    return;
  }

  const day = selectedButton.getAttribute('data-day');
  const product = getProductByDay(day);
  if (!product) return;

  setActiveDay(selectedButton, section);
  updateShowcase(product, section);
}

function bindDailyNavEvents(root = document) {
  const section = getRedeemSection(root);
  if (!section) return;

  const buttonEl = section.querySelector('[data-redeem-button]');
  const navs = section.querySelectorAll('[data-redeem-nav]');
  if (!navs.length) return;

  navs.forEach((nav) => {
    if (nav.dataset.redeemEventsBound === 'true') return;

    nav.dataset.redeemEventsBound = 'true';
    nav.addEventListener('click', (event) => {
      const selectedButton = event.target.closest('.redeem-daily-card');
      if (!selectedButton) return;

      activateDailyCard(selectedButton, section);
    });
    nav.addEventListener('keydown', (event) => {
      const selectedButton = event.target.closest('.redeem-daily-card');
      if (!selectedButton) return;

      focusDailyCardByKey(event, selectedButton, section);
    });
  });

  // Block disabled CTA clicks in script, not only through CSS styling.
  if (buttonEl && buttonEl.dataset.redeemEventsBound !== 'true') {
    buttonEl.dataset.redeemEventsBound = 'true';

    buttonEl.addEventListener('click', (event) => {
      const isDisabled =
        buttonEl.classList.contains('is-disabled') ||
        buttonEl.getAttribute('aria-disabled') === 'true';

      if (isDisabled) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }
}

function renderRedeemSection(section) {
  renderDailyNav(section);
  bindDailyNavEvents(section);
  bindShowcaseHeightSync();

  const initialProduct = getInitialProduct();
  if (!initialProduct) return;

  const initialButton = section.querySelector(
    `.redeem-daily-card[data-day="${initialProduct.day}"]`
  );

  if (initialButton) {
    setActiveDay(initialButton, section);
  }

  updateShowcase(initialProduct, section);

  const runHeightSync = () => syncShowcaseContentHeight(section);
  if (document.fonts?.ready) {
    document.fonts.ready.then(runHeightSync).catch(runHeightSync);
  } else {
    runHeightSync();
  }
}

function initRedeemSection(root = document) {
  const section = getRedeemSection(root);
  if (!section) return;

  renderRedeemSection(section);

  hydrateRedeemProducts(section).then((didUpdate) => {
    if (didUpdate) {
      renderRedeemSection(section);
    }
  });
}

function initRedeemSections(root = document) {
  forEachRedeemSection(root, initRedeemSection);
}

function initWhenReady() {
  initRedeemTestPanel();
  bindAnalyticsClickTracking();
  initRedeemSections(document);
}

window.msiCheatCodeRedeem = {
  init: initRedeemSections,
  syncHeight: syncAllShowcaseContentHeights
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWhenReady, { once: true });
} else {
  initWhenReady();
}

// Shopify theme editor replaces section DOM without a full page load.
document.addEventListener('shopify:section:load', (event) => {
  initRedeemSections(event.target);
});

document.addEventListener('shopify:section:select', (event) => {
  initRedeemSections(event.target);
  forEachRedeemSection(event.target, syncShowcaseContentHeight);
});
})();
